module.exports = __webpack_public_path__ + "img/slide-15_medium.d78fe50f.png";